import React, { useState, useEffect, useRef } from 'react';
import './ProfilePopover.css';
import ElephantBadgeIcon from './ElephantBadgeIcon';

// Цвета статусов
const ROLE_DOT = {
  moderator: { color: '#eab308', label: 'Модератор' },
  admin:     { color: '#ef4444', label: 'Админ' },
  teacher:   { color: '#a855f7', label: 'Учитель' },
  user:      { color: '#22c55e', label: 'Участник' },
};

const BADGE_LABELS = {
  registration: 'За регистрацию',
  pink_elephant: 'Розовый слоник — за хорошие подсказки',
};

function daysSince(iso){
  if(!iso) return 0;
  const d=Math.floor((Date.now()-new Date(iso).getTime())/86400000);
  return d<0?0:d;
}
function daysLabel(n){
  const a=Math.abs(n)%100, b=a%10;
  if(a>10&&a<20) return n+' дней';
  if(b===1) return n+' день';
  if(b>=2&&b<=4) return n+' дня';
  return n+' дней';
}

function StatusDot({ role, blocked, status }) {
  const color = blocked ? '#374151' : (status==='pending' ? '#94a3b8' : (ROLE_DOT[role]?.color || '#22c55e'));
  return (
    <span className="pp-status-dot" style={{ '--dot-color': color }}>
      <span className="pp-status-dot-inner" />
    </span>
  );
}

function AccordionBlock({ title, isOpen, onToggle, children, pulse, dataLessonTarget }) {
  return (
    <div className="pp-accordion" data-lesson-target={dataLessonTarget}>
      <button className={"pp-accordion-btn"+(pulse?" pp-pulse-btn":"")} type="button" onClick={onToggle}>
        <span>{title}{pulse&&<span className="pp-pulse-dot"/>}</span>
        <span className={`pp-accordion-arrow ${isOpen ? 'open' : ''}`}>›</span>
      </button>
      {isOpen && <div className="pp-accordion-body">{children}</div>}
    </div>
  );
}

// Маятник-переключатель для одного действия модерации

const Accordion=AccordionBlock;
const MOD_CFG=[
  {key:'access',p:'Принять',m:'Отклонить',
   pi:(a)=><img src='/icons/v2/accept.png' width='24' height='24' style={{opacity:a?1:0.35}} alt='' />,
   mi:(a)=><img src='/icons/v2/reject.png' width='24' height='24' style={{opacity:a?1:0.35}} alt='' />},
  {key:'admin',p:'Назначить админом',m:'Отозвать статус',
   pi:(a)=><img src='/icons/v2/grant-admin.png' width='24' height='24' style={{opacity:a?1:0.35}} alt='' />,
   mi:(a)=><img src='/icons/v2/revoke-admin.png' width='24' height='24' style={{opacity:a?1:0.35}} alt='' />},
  {key:'teacher',p:'Назначить учителем',m:'Лишить статуса',
   pi:(a)=><img src='/icons/v2/grant-teacher.png' width='24' height='24' style={{opacity:a?1:0.35}} alt='' />,
   mi:(a)=><img src='/icons/v2/revoke-teacher.png' width='24' height='24' style={{opacity:a?1:0.35}} alt='' />},
  {key:'paid',p:'Сделать платным',m:'Снять платный статус',
   pi:(a)=><span style={{fontSize:'17px',fontWeight:700,color:'#16a34a',opacity:a?1:0.35}}>₽</span>,
   mi:(a)=><span style={{fontSize:'17px',fontWeight:700,color:'#dc2626',opacity:a?1:0.35}}>₽</span>},
  {key:'friend',p:'В друзья',m:'Удалить из друзей',
   pi:(a)=><img src='/icons/v2/add-friend.png?v=20260524c' width='24' height='24' style={{opacity:a?1:0.35}} alt='' />,
   mi:(a)=><img src='/icons/v2/remove-friend.png?v=20260524c' width='24' height='24' style={{opacity:a?1:0.35}} alt='' />},
  {key:'attention',p:'Обратить внимание',m:'Игнорировать',
   pi:(a)=><img src='/icons/v2/attention.png' width='24' height='24' style={{opacity:a?1:0.35}} alt='' />,
   mi:(a)=><img src='/icons/v2/ignore.png' width='24' height='24' style={{opacity:a?1:0.35}} alt='' />},
  {key:'subscribe',p:'Подписаться',m:'Отписаться',
   pi:(a)=><img src='/icons/v2/podpiska.png' width='24' height='24' style={{opacity:a?1:0.35}} alt='' />,
   mi:(a)=><img src='/icons/v2/otpiska.png' width='24' height='24' style={{opacity:a?1:0.35}} alt='' />},
  {key:'block',p:'Разблокировать',m:'Заблокировать',
   pi:(a)=><img src='/icons/v2/unblock.png' width='24' height='24' style={{opacity:a?1:0.35}} alt='' />,
   mi:(a)=><img src='/icons/v2/block.png' width='24' height='24' style={{opacity:a?1:0.35}} alt='' />},
  {key:'elephant',p:'Выдать слоника',m:'Забрать слоника',
   pi:(a)=><span style={{opacity:a?1:0.35,display:'inline-flex'}}><ElephantBadgeIcon size={24} pink/></span>,
   mi:(a)=><span style={{opacity:a?1:0.35,display:'inline-flex',filter:'grayscale(1)'}}><ElephantBadgeIcon size={24}/></span>},
];

export default function ProfilePopover({
  userProfile,
  profileStats,
  authStatus,
  moderationTarget,
  setModerationTarget,
  blockUserByIdentifier,
  unblockUserByIdentifier,
  changeProfileAvatar,
  onOpenVoiceSetup,
  logoutUser,
  deleteUserAccount,
  supabase,
  onlineUserCount,
  onDownloadDatabase,
  onImportDatabase,
  onOpenBackupRestore,
  onDownloadAllWords,
  addDefaultSkeleton,
  requestConfirm,
  lessonsCatalog,
  onStartLesson,
  forceOpenSection,
  onClose,
  theme,
  onToggleTheme,
}) {
  const [openSection, setOpenSection] = useState(null);
  const [subscribers, setSubscribers] = useState([]);
  const [subsOpen, setSubsOpen] = useState(false);
  const [following, setFollowing] = useState([]);
  const [followingOpen, setFollowingOpen] = useState(false);
  const [friendsOpen, setFriendsOpen] = useState(false);
  const [photoModal, setPhotoModal] = useState(null);
  const isBlocked = userProfile?.status === 'blocked';
  const isModerator = userProfile?.role === 'moderator';
  const canObserve = ['moderator', 'admin'].includes(userProfile?.role);
  const [creators, setCreators] = useState(null);
  const [creatorsLoading, setCreatorsLoading] = useState(false);
  const [expandedCreator, setExpandedCreator] = useState(null);
  const [phraseCreators,setPhraseCreators]=useState(null);
  const [phraseCreatorsLoading,setPhraseCreatorsLoading]=useState(false);
  const [expandedPhraseCreator,setExpandedPhraseCreator]=useState(null);
  const [targetProfile,setTargetProfile]=useState(null);
  const [targetLoading,setTargetLoading]=useState(false);
  const [isTyping,setIsTyping]=useState(false);
  const [candidates,setCandidates]=useState([]);

  const [sysStats,setSysStats]=useState(null);
  const [sysStatsLoading,setSysStatsLoading]=useState(false);
  const [myFriendships,setMyFriendships]=useState(null);
  const [aiStats,setAiStats]=useState(null);
  const [aiStatsLoading,setAiStatsLoading]=useState(false);
  const [songCreators,setSongCreators]=useState(null);
  const [songCreatorsLoading,setSongCreatorsLoading]=useState(false);
  const [expandedSongCreator,setExpandedSongCreator]=useState(null);
  const ppRootRef = useRef(null);
  const ppIdleRef = useRef(null);
  useEffect(() => {
    if (typeof onClose !== 'function') return undefined;
    const reset = () => {
      if (ppIdleRef.current) clearTimeout(ppIdleRef.current);
      ppIdleRef.current = setTimeout(() => { onClose(); }, 30000);
    };
    const target = ppRootRef.current || document;
    const evs = ['mousemove', 'mousedown', 'keydown', 'touchstart', 'wheel', 'scroll'];
    evs.forEach((e) => target.addEventListener(e, reset, { passive: true, capture: true }));
    reset();
    return () => {
      if (ppIdleRef.current) clearTimeout(ppIdleRef.current);
      evs.forEach((e) => target.removeEventListener(e, reset, { capture: true }));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);



  const loadSongCreators = async () => {
    setSongCreatorsLoading(true);
    try {
      let token = '';
      try { const { data } = await supabase.auth.getSession(); token = (data && data.session && data.session.access_token) || ''; } catch (_) {}
      const res = await fetch('/api/ai/song-creators', {
        method: 'POST',
        headers: Object.assign({ 'Content-Type': 'application/json' }, token ? { Authorization: 'Bearer ' + token } : {}),
        body: JSON.stringify({ user: (userProfile && userProfile.id) || '' }),
      });
      const j = await res.json();
      let list = (j && j.ok && Array.isArray(j.creators)) ? j.creators : [];
      try {
        const { data: wc } = await supabase.rpc('moderator_word_creators');
        const map = {};
        if (Array.isArray(wc)) wc.forEach((w) => { if (w && w.owner_id) map[w.owner_id] = { nickname: w.nickname, role: w.role }; });
        list = list.map((cr) => {
          if (cr.nick) return cr;
          const m = map[cr.uid];
          if (m && m.nickname) return { ...cr, nick: m.nickname, role: m.role };
          if (cr.uid === (userProfile && userProfile.id)) return { ...cr, nick: userProfile && userProfile.nickname };
          return cr;
        });
      } catch (_) {}
      setSongCreators(list);
    } catch (e) { setSongCreators([]); }
    setSongCreatorsLoading(false);
  };

  const loadCreators = async () => {
    setCreatorsLoading(true);
    try {
      const { data, error } = await supabase.rpc('moderator_word_creators');
      if (!error && Array.isArray(data)) setCreators(data);
      else setCreators([]);
    } catch (e) { setCreators([]); }
    setCreatorsLoading(false);
  };

  const loadPhraseCreators = async () => {
    setPhraseCreatorsLoading(true);
    try {
      const { data, error } = await supabase.rpc('moderator_phrase_creators');
      if (!error && Array.isArray(data)) setPhraseCreators(data);
      else setPhraseCreators([]);
    } catch (e) { setPhraseCreators([]); }
    setPhraseCreatorsLoading(false);
  };

  const aiTypeLabel = (k) => ({
    photo: 'Распознавание с фото',
    recognize: 'Определение слова',
    card: 'Карточка слова',
    refresh: 'Обновление карточки',
    image: 'Картинка к слову',
    song_full: 'Песня (полная)',
    song_short: 'Песня (короткая)',
    song_lyrics: 'Текст песни (Gemini)',
    other: 'Прочее',
  }[k] || k);

  const loadAiStats = async () => {
    setAiStatsLoading(true);
    try {
      let token = '';
      try { const { data } = await supabase.auth.getSession(); token = (data && data.session && data.session.access_token) || ''; } catch (_) {}
      const res = await fetch('/api/ai/stats', {
        method: 'POST',
        headers: Object.assign({ 'Content-Type': 'application/json' }, token ? { Authorization: 'Bearer ' + token } : {}),
        body: JSON.stringify({ user: (userProfile && userProfile.id) || '' }),
      });
      const j = await res.json();
      if (j && j.ok) setAiStats(j);
      else setAiStats({ error: (j && j.error) === 'forbidden' ? 'Нет доступа' : ((j && j.error) || 'Ошибка загрузки') });
    } catch (e) { setAiStats({ error: 'Сеть недоступна' }); }
    setAiStatsLoading(false);
  };


  const loadMyFriendships=async()=>{
    try{
      const {data}=await supabase.rpc("get_my_friendships");
      if(data)setMyFriendships(data);
    }catch(e){}
  };


  const loadSysStats=async()=>{
    setSysStatsLoading(true);
    try{
      const {data,error}=await supabase.rpc("get_system_stats");
            if(!error&&data)setSysStats(data);
      else if(error)console.error("STATS ERROR:",error);
    }catch(e){console.error("STATS CATCH:",e);}
    setSysStatsLoading(false);
  };

  const [pendingUsers,setPendingUsers]=useState(null);
  const [pendingLoading,setPendingLoading]=useState(false);
  const [showPending,setShowPending]=useState(false);
  const [checkedIds,setCheckedIds]=useState([]);
  const [approving,setApproving]=useState(false);

  const loadPendingUsers=async()=>{
    setPendingLoading(true);
    try{
      const {data}=await supabase.rpc('get_pending_users');
      setPendingUsers(data||[]);
      setCheckedIds([]);
    }catch(e){}
    setPendingLoading(false);
  };

  const approveSelected=async()=>{
    if(!checkedIds.length)return;
    setApproving(true);
    try{
      await supabase.rpc('approve_users',{user_ids:checkedIds});
      await loadPendingUsers();
      setSysStats(null);
    }catch(e){}
    setApproving(false);
  };


  // Поиск пользователя по нику/email
  const searchTimer=useRef(null);
  useEffect(()=>{
    if(!moderationTarget.trim()){setTargetProfile(null);setCandidates([]);setIsTyping(false);return;}
    setIsTyping(true);
    clearTimeout(searchTimer.current);
    searchTimer.current=setTimeout(async()=>{
      setTargetLoading(true);
      const q=moderationTarget.trim().toLowerCase();
      if(isModerator){
        const {data}=await supabase.rpc("moderator_search_users",{target:q});
        const list=(Array.isArray(data)?data:[]).filter(u=>u&&u.id!==userProfile?.id);
        if(list.length===1){
          const one=list[0];
          const {data:full}=await supabase.rpc("moderator_find_user",{target:(one.email||one.nickname||"").toLowerCase()});
          setTargetProfile((full&&full.id===userProfile?.id)?null:(full||null));
          setCandidates([]);
        }else{setTargetProfile(null);setCandidates(list);}
      }else{
        const {data}=await supabase.rpc("find_user_public",{target:q});
        setTargetProfile((data&&data.id===userProfile?.id)?null:(data||null));
        setCandidates([]);
      }
      setTargetLoading(false);
      setIsTyping(false);
    },500);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[moderationTarget,supabase]);

  const pickCandidate=async(u)=>{
    if(!u)return;
    setTargetLoading(true);
    const {data:full}=await supabase.rpc("moderator_find_user",{target:(u.email||u.nickname||"").toLowerCase()});
    setTargetProfile((full&&full.id===userProfile?.id)?null:(full||null));
    setCandidates([]);
    setTargetLoading(false);
  };

  // Модерация: состояния
  const [modActions,setModActions]=useState({access:null,block:null,admin:null,teacher:null,friend:null,attention:null,subscribe:null,paid:null});
  const [confirmedActions,setConfirmedActions]=useState({access:null,block:null,admin:null,teacher:null,friend:null,attention:null,subscribe:null,paid:null});
  const [pendingKey,setPendingKey]=useState(null);
  const [pendingDir,setPendingDir]=useState(null);
  const [modCode,setModCode]=useState('');
  const [modResult,setModResult]=useState('');
  const [modErrMsg,setModErrMsg]=useState('');
  // eslint-disable-next-line no-unused-vars
  const [friendPending,setFriendPending]=useState(false);
  const [subPending,setSubPending]=useState(false);

  // При нахождении пользователя — отражаем его статус в маятниках
  useEffect(()=>{
    if(!targetProfile){setConfirmedActions({access:null,block:null,admin:null,teacher:null,friend:null,attention:null,subscribe:null,paid:null});setModActions({access:null,block:null,admin:null,teacher:null,friend:null,attention:null,subscribe:null,paid:null});return;}
    const st=targetProfile.status; const ro=targetProfile.role;
    const ml=targetProfile.mod_log||{};
    const ms={
      access:st==='active'?'plus':st==='blocked'?'minus':(ml.access||null),
      block:st==='blocked'?'minus':(ml.block||null),
      admin:ro==='admin'?'plus':(ml.admin||null),
      teacher:ro==='teacher'?'plus':(ml.teacher||null),
      friend:targetProfile.friendship_status==='accepted'?'plus':targetProfile.i_removed?'minus':(targetProfile.friendship_status==='pending'&&targetProfile.i_sent)?'plus':null,
      attention:ml.attention||null,
      subscribe:(targetProfile.is_subscribed||(Array.isArray(following)&&following.some(f=>f&&f.id===targetProfile.id)))?'plus':null,
      paid:ro==='paid'?'plus':null,
    };
    setConfirmedActions(ms);
    setModActions(ms);
  },[targetProfile,following]);

  const toggle=(s)=>setOpenSection(p=>p===s?null:s);
  // Загружаем дружбы при монтировании
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const loadSubscribers=async()=>{
    try{
      const {data}=await supabase.rpc("get_my_subscriptions");
      if(data){
        setSubscribers(Array.isArray(data.followers)?data.followers:[]);
        setFollowing(Array.isArray(data.following)?data.following:[]);
      }
    }catch{ /* noop */ }
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(()=>{ if(userProfile?.id){loadMyFriendships();loadSubscribers();} },[userProfile?.id]);

  // Внешнее управление раскрытием раздела (для уроков-туров)
  useEffect(() => {
    if (forceOpenSection) setOpenSection(forceOpenSection);
  }, [forceOpenSection]);


  const MOD_LABELS={
    access:{plus:'одобрить как пользователя',minus:'отклонить от права пользования'},
    block:{plus:'разблокировать ',minus:'заблокировать '},
    admin:{plus:'назначить админом ',minus:'отозвать статус админа у '},
    teacher:{plus:'назначить учителем ',minus:'отозвать статус учителя у '},
    paid:{plus:'сделать платным ',minus:'снять платный статус у '},
    friend:{plus:'принять в друзья ',minus:'удалить из друзей '},
    attention:{plus:'обратить внимание на ',minus:'игнорировать '},
    elephant:{plus:'выдать розового слоника ',minus:'забрать розового слоника у '},
  };

  const handleToggle=(key,dir)=>{
    if(!moderationTarget.trim())return;
    if(confirmedActions[key]===dir)return;
    // Нельзя снять выбор пока не введён код
    if(pendingKey===key&&pendingDir===dir)return;
    // Если был другой pending без кода - сбросить его
    if(pendingKey&&pendingKey!==key){
      setModActions(p=>({...p,[pendingKey]:confirmedActions[pendingKey]||null}));
    }
    // Для дружбы у обычного пользователя - показываем подтверждение
    if(key==="friend"&&userProfile?.role!=="moderator"&&targetProfile?.id){
      setModActions(p=>({...p,friend:dir}));
      setFriendPending(true);
      setModResult("");
      return;
    }
    // Подписка обычного пользователя — через подтверждение
    if(key==="subscribe"&&targetProfile?.id){
      setModActions(p=>({...p,subscribe:dir}));
      setSubPending(true);
      setModResult("");
      return;
    }
    setPendingKey(key); setPendingDir(dir); setModCode(""); setModResult("");
    setModActions(p=>({...p,[key]:dir}));
  };

  const handleCodeSubmit=async()=>{
    const code=modCode.trim();
    if(code.length!==6)return;
    setModResult('loading');
    try{
      const r=await fetch('/totp/verify-totp',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({code})});
      const d=await r.json();
      if(d.ok){
        const tid=targetProfile?.id;
        if(pendingKey==='block'){if(pendingDir==='minus')await blockUserByIdentifier({preventDefault:()=>{}});else await unblockUserByIdentifier();}
        if(pendingKey==='admin'&&tid)await supabase.rpc('moderator_set_role',{target_id:tid,new_role:pendingDir==='plus'?'admin':'user'});
        if(pendingKey==='teacher'&&tid)await supabase.rpc('moderator_set_role',{target_id:tid,new_role:pendingDir==='plus'?'teacher':'user'});
        if(pendingKey==='paid'&&tid)await supabase.rpc('moderator_set_role',{target_id:tid,new_role:pendingDir==='plus'?'paid':'user'});
        if(pendingKey==='access'&&tid)await supabase.from('profiles').update({status:pendingDir==='plus'?'active':'blocked'}).eq('id',tid);
        if(pendingKey==='friend'&&tid){
          if(pendingDir==='plus')await supabase.rpc('send_friend_request',{target_id:tid});
          else await supabase.rpc('remove_friend',{target_id:tid});
        }
        if(pendingKey==='elephant'&&tid){
          const {error:eErr}=await supabase.rpc('moderator_set_pink_elephant',{target_id:tid,grant_it:pendingDir==='plus'});
          if(eErr){setModErrMsg(eErr.message||'ошибка');setModResult('rpc_error');return;}
        }
        if(pendingKey==='elephant'){setModActions(p=>({...p,elephant:null}));setConfirmedActions(p=>({...p,elephant:null}));}
        else setConfirmedActions(p=>({...p,[pendingKey]:pendingDir}));
        if(tid&&pendingKey!=='elephant')await supabase.rpc('moderator_log_action',{target_id:tid,action_key:pendingKey,direction:pendingDir});
        setModResult('success');setPendingKey(null);setPendingDir(null);setModCode('');
        const {data:rd}=await supabase.rpc('moderator_find_user',{target:moderationTarget.trim().toLowerCase()});
        setTargetProfile((rd&&rd.id===userProfile?.id)?null:(rd||null));
        setTimeout(()=>setModResult(''),3000);
      }else{setModResult('error');}
    }catch(e){setModResult('error');}
  };


  return (
    <aside ref={ppRootRef} className="pp-popover" aria-label="Профиль" onClick={e=>e.stopPropagation()}>

      {/* Шапка */}
      <div className="pp-header">
        <div className="pp-avatar-wrap">
          {userProfile?.photo?.dataUrl ? (
            <img className="pp-avatar-img" src={userProfile.photo.dataUrl} alt={userProfile.nickname} style={{width:44,height:44,minWidth:44,maxWidth:44,borderRadius:"50%",objectFit:"cover",flexShrink:0,cursor:"pointer"}} onClick={(e)=>{e.stopPropagation();setPhotoModal(userProfile.photo.dataUrl);}} />
          ) : (
            <span className="pp-avatar-initial">
              {(userProfile?.nickname || userProfile?.email || 'U')[0].toUpperCase()}
            </span>
          )}
          <StatusDot role={userProfile?.role} blocked={isBlocked} status={userProfile?.status} />
        </div>
        <div className="pp-header-text" style={{display:"flex",flexDirection:"column",gap:"2px",minWidth:0,overflow:"hidden"}}>
          <strong className="pp-nickname">{userProfile?.nickname}</strong>
          <span className="pp-email">{userProfile?.email}</span>
        </div>
        {typeof onClose === 'function' && (
          <button type="button" className="pp-close-btn" aria-label="Закрыть меню" onClick={(e)=>{e.stopPropagation();onClose();}}>×</button>
        )}
      </div>

      {authStatus && <p className="pp-status-msg">{authStatus}</p>}

      <div className="pp-theme-row">
        <span className="pp-theme-label">Тёмная тема</span>
        <button
          type="button"
          className={'pp-theme-switch' + (theme === 'dark' ? ' is-on' : '')}
          role="switch"
          aria-checked={theme === 'dark'}
          onClick={() => { if (typeof onToggleTheme === 'function') onToggleTheme(); }}
        >
          <span className="pp-theme-knob" />
        </button>
      </div>

      {/* Модерация */}
      {isModerator && (
        <Accordion title="Модерация" isOpen={openSection==='mod'} onToggle={()=>{toggle('mod');if(openSection!=='mod')loadMyFriendships();}} pulse={myFriendships?.incoming?.length>0}>
          <input className="pp-mod-input" type="text" value={moderationTarget}
            onChange={e=>setModerationTarget(e.target.value)}
            placeholder="Ник или email" maxLength={80} />
          {(targetLoading||isTyping)&&<p className="pp-target-hint">Идёт поиск...</p>}
          {!targetLoading&&!isTyping&&moderationTarget.trim()&&!targetProfile&&candidates.length===0&&<p className="pp-target-hint pp-target-notfound">Не найден</p>}
          {!targetProfile&&candidates.length>0&&(
            <div className="pp-cand-list">
              {candidates.map(u=>(
                <button key={u.id} type="button" className="pp-cand-item" onClick={()=>pickCandidate(u)}>
                  {u.avatar?.dataUrl?<img src={u.avatar.dataUrl} alt="" className="pp-cand-ava"/>:<span className="pp-cand-initial">{(u.nickname||u.email||"?")[0].toUpperCase()}</span>}
                  <span className="pp-cand-text"><span className="pp-cand-nick">{u.nickname||u.email}</span><span className="pp-cand-email">{u.email}</span></span>
                </button>
              ))}
            </div>
          )}
          {moderationTarget.trim()&&targetProfile&&(
            <div className="pp-target-card">
              <div className="pp-target-avatar-wrap">
                <div className="pp-target-avatar">
                  {targetProfile.avatar?.dataUrl?<img src={targetProfile.avatar.dataUrl} alt="" style={{width:38,height:38,borderRadius:"50%",objectFit:"cover",cursor:"pointer"}} onClick={()=>setPhotoModal(targetProfile.avatar.dataUrl)}/>:<span className="pp-target-initial">{(targetProfile.nickname||"?")[0].toUpperCase()}</span>}
                </div>
                <StatusDot role={targetProfile.role} status={targetProfile.status} blocked={targetProfile.status==='blocked'} />
              </div>
              <div className="pp-target-info">
                <div className="pp-target-top">
                  <span className="pp-target-nick">{targetProfile.nickname||targetProfile.email}</span>
                  {targetProfile.registered_at&&<span className="pp-target-days">{Math.floor((Date.now()-new Date(targetProfile.registered_at).getTime())/86400000)} дн.</span>}
                </div>
                {targetProfile.word_count!=null&&<div className="pp-target-words"><span>Слов и фраз</span><b>{targetProfile.word_count}</b></div>}
              </div>
            </div>
          )}
          {moderationTarget.trim()&&targetProfile&&<div className="pp-mod-toggles">
            {MOD_CFG.map(cfg=>{
              const cur=modActions[cfg.key];
              const isPending=pendingKey===cfg.key;
              return(<div key={cfg.key}>
                <div className="pp-mod-toggle-row">
                  <button type="button" disabled={cfg.key==="subscribe"&&confirmedActions.subscribe!=="plus"} className={"pp-mod-btn"+(cur==="minus"?" active-minus":"")} onClick={()=>handleToggle(cfg.key,"minus")}>{cfg.mi(cur==="minus")}</button>
                  <div className="pp-mod-track" style={{background:cur==="plus"?"#dcfce7":cur==="minus"?"#fee2e2":"#f1f5f9"}}><div className={"pp-mod-knob"+(cur==="plus"?" right":cur==="minus"?" left":"")}/></div>
                  <button type="button" disabled={cfg.key==="subscribe"&&confirmedActions.subscribe==="plus"} className={"pp-mod-btn"+(cur==="plus"?" active-plus":"")} onClick={()=>handleToggle(cfg.key,"plus")}>{cfg.pi(cur==="plus")}</button>
                </div>
                {isPending&&moderationTarget.trim()&&(
                  <div className="pp-inline-confirm">
                    <p className="pp-inline-msg">Вы хотите{": "}
                      {pendingDir==="plus"?<><span style={{color:"#16a34a",fontWeight:700}}>{MOD_LABELS[cfg.key].plus}</span>{" "}<b>{userProfile?.nickname||moderationTarget}</b></>:<><span style={{color:"#dc2626",fontWeight:700}}>{MOD_LABELS[cfg.key].minus}</span><b>{userProfile?.nickname||moderationTarget}</b></>}
                      {" — введите одноразовый код:"}</p>
                    <div className="pp-otp-row">
                      {[0,1,2,3,4,5].map(i=>(
                        <input key={i} id={"otp-"+i} className="pp-otp-cell" type="text" inputMode="numeric" maxLength={1} value={modCode[i]||""}
                          onChange={e=>{
                            const v=e.target.value.replace(/[^0-9]/g,"");
                            const arr=(modCode+"      ").split("").slice(0,6);
                            arr[i]=v;
                            setModCode(arr.join("").trim());
                            setModResult("");
                            if(v&&i<5)document.getElementById("otp-"+(i+1))?.focus();
                          }}
                          onKeyDown={e=>{
                            if(e.key==="Backspace"&&!modCode[i]&&i>0)document.getElementById("otp-"+(i-1))?.focus();
                            if(e.key==="Enter")handleCodeSubmit();
                          }}
                        />
                      ))}
                    </div>
                    <button className="pp-code-submit-full" type="button" onClick={handleCodeSubmit}>Ввод</button>
                    {modResult==="loading"&&<p className="pp-confirm-ok" style={{color:"#6366f1"}}>⏳ Проверка...</p>}{modResult==="success"&&<p className="pp-confirm-ok">✓ Применено</p>}
                    {modResult==="error"&&<p className="pp-confirm-err">Неверный код</p>}
                    {modResult==="rpc_error"&&<p className="pp-confirm-err">Не удалось выдать: {modErrMsg}</p>}
                  </div>
                )}
                {cfg.key==="subscribe"&&subPending&&(
                  <div className="pp-inline-confirm">
                    <p className="pp-inline-msg">
                      {modActions.subscribe==="plus"
                        ? <span>Вы хотите подписаться на <b>{targetProfile.nickname||targetProfile.email}</b>?</span>
                        : <span>Вы хотите отписаться от <b>{targetProfile.nickname||targetProfile.email}</b>?</span>}
                    </p>
                    <button className="pp-code-submit-full" type="button" onClick={async()=>{
                      const fn=modActions.subscribe==="plus"?"subscribe":"unsubscribe";
                      const {error}=await supabase.rpc(fn,{author:targetProfile.id});
                      if(!error){
                        const nd=fn==="subscribe"?"plus":"minus";
                        setConfirmedActions(p=>({...p,subscribe:nd}));
                        setModActions(p=>({...p,subscribe:nd}));
                        setSubPending(false);
                        loadSubscribers();
                      }
                    }}>Подтвердить</button>
                    <button className="pp-confirm-back" type="button" onClick={()=>{setSubPending(false);setModActions(p=>({...p,subscribe:confirmedActions.subscribe||null}));}}>← Отмена</button>
                  </div>
                )}
              </div>);
            })}
          </div>}
          {myFriendships?.incoming?.length>0&&(
            <div className="pp-incoming-requests">
              <p className="pp-incoming-title">Запросы в друзья:</p>
              {myFriendships.incoming.map(u=>(
                <div key={u.id} className="pp-incoming-row">
                  <div className="pp-incoming-avatar">{u.avatar?.dataUrl?<img src={u.avatar.dataUrl} alt="" style={{width:28,height:28,borderRadius:"50%",objectFit:"cover"}}/>:<span className="pp-incoming-initial">{(u.nickname||"?")[0].toUpperCase()}</span>}</div>
                  <span className="pp-target-nick" style={{flex:1}}>{u.nickname}</span>
                  <button className="pp-friend-accept" onClick={()=>supabase.rpc("respond_friend_request",{requester_id:u.id,accept:true}).then(async()=>{loadMyFriendships();if(targetProfile?.id===u.id){setTargetProfile(p=>p?{...p,is_friend:true,friendship_status:"accepted",i_sent:false}:p);setConfirmedActions(p=>({...p,friend:"plus"}));setModActions(p=>({...p,friend:"plus"}));}})}>✓</button>
                  <button className="pp-friend-decline" onClick={()=>supabase.rpc("respond_friend_request",{requester_id:u.id,accept:false}).then(()=>loadMyFriendships())}>✕</button>
                </div>
              ))}
            </div>
          )}
        </Accordion>
      )}
      {canObserve && (
        <Accordion title="Создатели слов" isOpen={openSection==='creators'} onToggle={()=>{toggle('creators');if(openSection!=='creators')loadCreators();}}>
          {creatorsLoading && <p className="pp-target-hint">Загрузка…</p>}
          {!creatorsLoading && creators && creators.length===0 && <p className="pp-target-hint">Пока никто не создавал слов</p>}
          {!creatorsLoading && creators && creators.length>0 && (
            <div className="pp-creators">
              {creators.map((cr)=>(
                <div key={cr.owner_id} className="pp-creator">
                  <button type="button" className="pp-creator-head" onClick={()=>setExpandedCreator(expandedCreator===cr.owner_id?null:cr.owner_id)}>
                    <span className="pp-creator-nick">{cr.nickname}{cr.role==='admin'?' · админ':(cr.role==='paid'?' · платный':'')}</span>
                    <span className="pp-creator-count">{cr.count}</span>
                  </button>
                  {expandedCreator===cr.owner_id && (
                    <ul className="pp-creator-words">
                      {(cr.words||[]).map((w,i)=>(<li key={i}>{typeof w==='object'?w.word:w}</li>))}
                    </ul>
                  )}
                </div>
              ))}
            </div>
          )}
        </Accordion>
      )}
      {canObserve && (
        <Accordion title="Заказчики фраз" isOpen={openSection==='phrasecreators'} onToggle={()=>{toggle('phrasecreators');if(openSection!=='phrasecreators')loadPhraseCreators();}}>
          {phraseCreatorsLoading && <p className="pp-target-hint">Загрузка…</p>}
          {!phraseCreatorsLoading && phraseCreators && phraseCreators.length===0 && <p className="pp-target-hint">Пока никто не заказывал фраз</p>}
          {!phraseCreatorsLoading && phraseCreators && phraseCreators.length>0 && (
            <div className="pp-creators">
              {phraseCreators.map((cr)=>(
                <div key={cr.owner_id} className="pp-creator">
                  <button type="button" className="pp-creator-head" onClick={()=>setExpandedPhraseCreator(expandedPhraseCreator===cr.owner_id?null:cr.owner_id)}>
                    <span className="pp-creator-nick">{cr.nickname}{cr.role==='admin'?' · админ':(cr.role==='paid'?' · платный':'')}</span>
                    <span className="pp-creator-count">{cr.count}</span>
                  </button>
                  {expandedPhraseCreator===cr.owner_id && (
                    <ul className="pp-creator-words">
                      {(cr.words||[]).map((w,i)=>(<li key={i}>{typeof w==='object'?w.word:w}</li>))}
                    </ul>
                  )}
                </div>
              ))}
            </div>
          )}
        </Accordion>
      )}
      {canObserve && (
        <Accordion title="Создатели песен" isOpen={openSection==='songcreators'} onToggle={()=>{toggle('songcreators');if(openSection!=='songcreators'&&!songCreators)loadSongCreators();}}>
          {songCreatorsLoading && <p className="pp-target-hint">Загрузка…</p>}
          {!songCreatorsLoading && songCreators && songCreators.length===0 && <p className="pp-target-hint">Пока никто не создавал песен</p>}
          {!songCreatorsLoading && songCreators && songCreators.length>0 && (
            <div className="pp-creators">
              {songCreators.map((cr)=>{
                const nick = cr.nick || (cr.uid===userProfile?.id ? (userProfile?.nickname||'Вы') : (cr.uid? cr.uid.slice(0,8)+'…' : '—'));
                return (
                  <div key={cr.uid} className="pp-creator">
                    <button type="button" className="pp-creator-head" onClick={()=>setExpandedSongCreator(expandedSongCreator===cr.uid?null:cr.uid)}>
                      <span className="pp-creator-nick">{nick}{cr.role==='admin'?' · админ':(cr.role==='paid'?' · платный':'')}</span>
                      <span className="pp-creator-count">{cr.count}</span>
                    </button>
                    <div className="pp-ai-type-sub">полных: {cr.full} · коротких: {cr.short}</div>
                    {expandedSongCreator===cr.uid && (
                      <ul className="pp-creator-words">
                        {(cr.songs||[]).map((s,i)=>(<li key={i}>{s.word} <span className="pp-song-kind">{s.full?'полная':'короткая'}</span></li>))}
                      </ul>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </Accordion>
      )}
      {canObserve && (
        <Accordion title="Расход ИИ" isOpen={openSection==='aistats'} onToggle={()=>{toggle('aistats');if(openSection!=='aistats'&&!aiStats)loadAiStats();}}>
          {aiStatsLoading && <p className="pp-target-hint">Загрузка…</p>}
          {!aiStatsLoading && aiStats && aiStats.error && <p className="pp-target-hint">{aiStats.error}</p>}
          {!aiStatsLoading && aiStats && !aiStats.error && (
            <div className="pp-aistats">
              <div className="pp-ai-total">
                <span>Всего потрачено</span>
                <strong>${Number(aiStats.total.cost_usd).toFixed(4)}</strong>
              </div>
              <div className="pp-ai-subline">Токенов: {Number(aiStats.total.in).toLocaleString('ru-RU')} вход · {Number(aiStats.total.out).toLocaleString('ru-RU')} выход</div>
              <div className="pp-ai-types">
                {Object.entries(aiStats.by_type).sort((a,b)=>b[1].cost_usd-a[1].cost_usd).map(([k,v])=>(
                  <div key={k} className="pp-ai-type">
                    <div className="pp-ai-type-head">
                      <span className="pp-ai-type-name">{aiTypeLabel(k)}</span>
                      <span className="pp-ai-type-cost">${Number(v.cost_usd).toFixed(4)}</span>
                    </div>
                    <div className="pp-ai-type-sub">{v.count} раз · ${Number(v.per_unit_usd).toFixed(5)} за раз</div>
                  </div>
                ))}
              </div>
              {aiStats.by_day && aiStats.by_day.length>0 && (
                <div className="pp-ai-days">
                  <div className="pp-ai-days-title">По дням</div>
                  {aiStats.by_day.slice(-14).reverse().map((d)=>(
                    <div key={d.date} className="pp-ai-day"><span>{d.date}</span><span>${Number(d.cost_usd).toFixed(4)}</span></div>
                  ))}
                </div>
              )}
              <p className="pp-ai-note">Стоимость — оценка по ставкам (prices.json). Токены точные. Сверяйте с биллингом Google.</p>
            </div>
          )}
        </Accordion>
      )}
      {(lessonsCatalog && lessonsCatalog.length > 0) && (
        <AccordionBlock
          title="Обучение"
          isOpen={openSection === "lessons"}
          onToggle={() => toggle("lessons")}
        >
          <ul className="pp-lessons-list">
            {lessonsCatalog.map((lesson) => {
              const badges = Array.isArray(userProfile?.badges) ? userProfile.badges : [];
              const isDone = badges.includes(lesson.badgeKey);
              const isLocked = lesson.requiresBadge && !badges.includes(lesson.requiresBadge);
              if (isDone) {
                return (
                  <li key={lesson.id} className="pp-lesson-item-done">
                    <div className="pp-lesson-info">
                      <span className="pp-lesson-title">{lesson.title}</span>
                      {lesson.type === 'video' && (
                        <button
                          type="button"
                          className="pp-lesson-watch-again"
                          onClick={() => onStartLesson && onStartLesson(lesson.id)}
                        >посмотреть ещё раз</button>
                      )}
                    </div>
                    <span className="pp-lesson-badge" title="Урок пройден">
                      <ElephantBadgeIcon size={28} />
                    </span>
                  </li>
                );
              }
              if (isLocked) {
                const reqIdx = lessonsCatalog.findIndex((l) => l.badgeKey === lesson.requiresBadge);
                const reqNum = reqIdx >= 0 ? reqIdx + 1 : 1;
                return (
                  <li key={lesson.id} className="pp-lesson-item pp-lesson-locked">
                    <div className="pp-lesson-info">
                      <span className="pp-lesson-title">{lesson.title}</span>
                      <span className="pp-lesson-desc">{`Откроется после Урока ${reqNum}`}</span>
                    </div>
                    <div className="pp-lesson-side">
                      <span className="pp-lesson-lock" aria-hidden="true">🔒</span>
                    </div>
                  </li>
                );
              }
              return (
                <li key={lesson.id} className="pp-lesson-item">
                  <div className="pp-lesson-info">
                    <span className="pp-lesson-title">{lesson.title}</span>
                    <span className="pp-lesson-desc">{lesson.description}</span>
                  </div>
                  <div className="pp-lesson-side">
                    <button
                      type="button"
                      className="pp-lesson-btn"
                      onClick={() => onStartLesson && onStartLesson(lesson.id)}
                    >Начать</button>
                  </div>
                </li>
              );
            })}
          </ul>
        </AccordionBlock>
      )}

      {/* Модерация для обычных пользователей */}
      {!['moderator'].includes(userProfile?.role)&&(
        <AccordionBlock title="Модерация" isOpen={openSection==="user_mod"}
          onToggle={()=>{toggle("user_mod");if(openSection!=="user_mod")loadMyFriendships();}}
          pulse={myFriendships?.incoming?.length>0}>
          {userProfile?.status==="pending"&&<p className="pp-target-notfound" style={{margin:"8px 0",fontSize:"12px",textAlign:"center"}}>Дождитесь одобрения модератором</p>}
          {userProfile?.status!=="pending"&&<>
          <input className="pp-mod-input" type="text" value={moderationTarget} onChange={e=>setModerationTarget(e.target.value)} placeholder="Ник или email" maxLength={80} />
          {(targetLoading||isTyping)&&<p className="pp-target-hint">Идёт поиск...</p>}
          {!targetLoading&&!isTyping&&moderationTarget.trim()&&!targetProfile&&<p className="pp-target-hint pp-target-notfound">Не найден</p>}
          {targetProfile&&<div className="pp-target-card"><div className="pp-target-avatar">{targetProfile.avatar?.dataUrl?<img src={targetProfile.avatar.dataUrl} alt="" style={{width:36,height:36,borderRadius:"50%",objectFit:"cover"}} onClick={()=>setPhotoModal(targetProfile.avatar.dataUrl)}/>:<span className="pp-target-initial">{(targetProfile.nickname||"?")[0].toUpperCase()}</span>}</div><div className="pp-target-info"><div className="pp-target-top"><span className="pp-target-nick">{targetProfile.nickname||targetProfile.email}</span>{targetProfile.registered_at&&<span className="pp-target-days">{Math.floor((Date.now()-new Date(targetProfile.registered_at).getTime())/86400000)} дн.</span>}</div></div></div>}
          {targetProfile?.id!==userProfile?.id&&<div className="pp-mod-toggles">
            <div className="pp-mod-toggle-row">
              <button type="button" className={"pp-mod-btn"+(modActions.friend==="minus"?" active-minus":"")} onClick={()=>handleToggle("friend","minus")}>{MOD_CFG.find(c=>c.key==="friend").mi(modActions.friend==="minus")}</button>
              <div className="pp-mod-track" style={{background:modActions.friend==="plus"?"#dcfce7":modActions.friend==="minus"?"#fee2e2":"#f1f5f9"}}><div className={"pp-mod-knob"+(modActions.friend==="plus"?" right":modActions.friend==="minus"?" left":"")}/></div>
              <button type="button" className={"pp-mod-btn"+(modActions.friend==="plus"?" active-plus":"")} onClick={()=>handleToggle("friend","plus")}>{MOD_CFG.find(c=>c.key==="friend").pi(modActions.friend==="plus")}</button>
            </div>
          </div>}
          {targetProfile?.id!==userProfile?.id&&<div className="pp-mod-toggles">
            <div className="pp-mod-toggle-row">
              <button type="button" disabled={confirmedActions.subscribe!=="plus"} className={"pp-mod-btn"+(modActions.subscribe==="minus"?" active-minus":"")} onClick={()=>handleToggle("subscribe","minus")}>{MOD_CFG.find(c=>c.key==="subscribe").mi(modActions.subscribe==="minus")}</button>
              <div className="pp-mod-track" style={{background:modActions.subscribe==="plus"?"#dcfce7":modActions.subscribe==="minus"?"#fee2e2":"#f1f5f9"}}><div className={"pp-mod-knob"+(modActions.subscribe==="plus"?" right":modActions.subscribe==="minus"?" left":"")}/></div>
              <button type="button" disabled={confirmedActions.subscribe==="plus"} className={"pp-mod-btn"+(modActions.subscribe==="plus"?" active-plus":"")} onClick={()=>handleToggle("subscribe","plus")}>{MOD_CFG.find(c=>c.key==="subscribe").pi(modActions.subscribe==="plus")}</button>
            </div>
          </div>}
          {subPending&&targetProfile&&<div className="pp-inline-confirm">
              <p className="pp-inline-msg">
                {modActions.subscribe==="plus"
                  ? <span>Вы хотите подписаться на <b>{targetProfile.nickname||targetProfile.email}</b>?</span>
                  : <span>Вы хотите отписаться от <b>{targetProfile.nickname||targetProfile.email}</b>?</span>}
              </p>
              {modResult==="error"&&<p className="pp-confirm-err">Ошибка. Попробуйте ещё раз.</p>}
              <button className="pp-code-submit-full" type="button" onClick={async()=>{
                const fn=modActions.subscribe==="plus"?"subscribe":"unsubscribe";
                const {error}=await supabase.rpc(fn,{author:targetProfile.id});
                if(!error){
                  const nd=fn==="subscribe"?"plus":"minus";
                  setConfirmedActions(p=>({...p,subscribe:nd}));
                  setModActions(p=>({...p,subscribe:nd}));
                  setSubPending(false);
                }else setModResult("error");
              }}>Подтвердить</button>
              <button className="pp-confirm-back" type="button" onClick={()=>{setSubPending(false);setModActions(p=>({...p,subscribe:confirmedActions.subscribe||null}));}}>← Отмена</button>
          </div>}
          {friendPending&&targetProfile&&<div className="pp-inline-confirm">
              <p className="pp-inline-msg">Вы хотите{" "}
                {modActions.friend==="plus"?<span style={{color:"#16a34a",fontWeight:700}}>отправить запрос на дружбу </span>:targetProfile?.friendship_status==='accepted'?<span style={{color:"#dc2626",fontWeight:700}}>прекратить дружбу с </span>:<span style={{color:"#dc2626",fontWeight:700}}>отозвать запрос на дружбу у </span>}
                <b>{targetProfile.nickname||targetProfile.email}</b>
              </p>
              {modResult==="success"&&<p className="pp-confirm-ok">✓ Запрос отправлен</p>}
              {modResult==="error"&&<p className="pp-confirm-err">Ошибка. Попробуйте ещё раз.</p>}
              {!modResult&&<button className="pp-code-submit-full" type="button" onClick={async()=>{
                const isFriend=confirmedActions.friend==="plus"||targetProfile?.friendship_status==="accepted";
                const fn=modActions.friend==="minus"&&isFriend?"remove_friend":"send_friend_request";
                const {error}=await supabase.rpc(fn,{target_id:targetProfile.id});
                if(!error){
                  const nd=fn==="remove_friend"?"minus":"plus";
                  setConfirmedActions(p=>({...p,friend:nd}));setModActions(p=>({...p,friend:nd}));
                  loadMyFriendships();setModResult("success");setFriendPending(false);setTimeout(()=>setModResult(""),3000);
                }else setModResult("error");
              }}>Подтвердить</button>}
              <button className="pp-confirm-back" type="button" onClick={()=>{setFriendPending(false);setModActions(p=>({...p,friend:confirmedActions.friend||null}));}}>← Отмена</button>
          </div>}
          </>
          }
          {myFriendships?.incoming?.length>0&&(
            <div className="pp-incoming-requests">
              <p className="pp-incoming-title">Запросы в друзья:</p>
              {myFriendships.incoming.map(u=>(
                <div key={u.id} className="pp-incoming-row">
                  <div className="pp-incoming-avatar">{u.avatar?.dataUrl?<img src={u.avatar.dataUrl} alt="" style={{width:28,height:28,borderRadius:"50%",objectFit:"cover"}}/>:<span className="pp-incoming-initial">{(u.nickname||"?")[0].toUpperCase()}</span>}</div>
                  <span className="pp-target-nick" style={{flex:1}}>{u.nickname}</span>
                  <button className="pp-friend-accept" onClick={()=>supabase.rpc("respond_friend_request",{requester_id:u.id,accept:true}).then(async()=>{loadMyFriendships();if(targetProfile?.id===u.id){setTargetProfile(p=>p?{...p,is_friend:true,friendship_status:"accepted",i_sent:false}:p);setConfirmedActions(p=>({...p,friend:"plus"}));setModActions(p=>({...p,friend:"plus"}));}})}>✓</button>
                  <button className="pp-friend-decline" onClick={()=>supabase.rpc("respond_friend_request",{requester_id:u.id,accept:false}).then(()=>loadMyFriendships())}>✕</button>
                </div>
              ))}
            </div>
          )}
        </AccordionBlock>
      )}


      {!['moderator'].includes(userProfile?.role)&&(
        <AccordionBlock title="Статистика" isOpen={openSection==="user_stats"}
          dataLessonTarget="section-user_stats"
          onToggle={()=>{toggle("user_stats");if(openSection!=="user_stats")loadMyFriendships();}}>
          <div className="pp-stats-grid">
            <button type="button" className="pp-subs-toggle" onClick={()=>setFriendsOpen(o=>!o)}>
              <span>Друзья</span><b>{myFriendships?.friends_count??0} {friendsOpen?'▲':'▼'}</b>
            </button>
          </div>
          {friendsOpen && (myFriendships?.friends?.length > 0 ? (
            <div className="pp-subs-list">
              {myFriendships.friends.map((fr) => (
                <div className="pp-subs-row" key={fr.id}>
                  <button type="button" className="pp-subs-nick pp-subs-nick-btn" onClick={() => { setModerationTarget(fr.nickname || ''); setOpenSection(userProfile?.role === 'moderator' ? 'mod' : 'user_mod'); }}>{fr.nickname || 'участник'}</button>
                </div>
              ))}
            </div>
          ) : (
            <p className="pp-subs-empty">Пока нет друзей</p>
          ))}
          <div className="pp-stats-grid">
            <button type="button" className="pp-subs-toggle" onClick={()=>setSubsOpen(o=>!o)}>
              <span>Подписчики</span><b>{subscribers.length} {subsOpen?'▲':'▼'}</b>
            </button>
          </div>
          {subsOpen && (subscribers.length > 0 ? (
            <div className="pp-subs-list">
              {subscribers.map((s) => (
                <div className="pp-subs-row" key={s.id}>
                  <button type="button" className="pp-subs-nick pp-subs-nick-btn" onClick={() => { setModerationTarget(s.nickname || ''); setOpenSection(userProfile?.role === 'moderator' ? 'mod' : 'user_mod'); }}>{s.nickname || 'участник'}</button>
                  <span className="pp-subs-days">{daysLabel(daysSince(s.created_at))}</span>
                </div>
              ))}
            </div>
          ) : (
            <p className="pp-subs-empty">Пока нет подписчиков</p>
          ))}

          <div className="pp-stats-grid">
            <button type="button" className="pp-subs-toggle" onClick={()=>setFollowingOpen(o=>!o)}>
              <span>Мои подписки</span><b>{following.length} {followingOpen?'▲':'▼'}</b>
            </button>
          </div>
          {followingOpen && (following.length > 0 ? (
            <div className="pp-subs-list">
              {following.map((s) => (
                <div className="pp-subs-row" key={s.id}>
                  <button type="button" className="pp-subs-nick pp-subs-nick-btn" onClick={() => { setModerationTarget(s.nickname || ''); setOpenSection(userProfile?.role === 'moderator' ? 'mod' : 'user_mod'); }}>{s.nickname || 'участник'}</button>
                  <span className="pp-subs-days">{daysLabel(daysSince(s.created_at))}</span>
                </div>
              ))}
            </div>
          ) : (
            <p className="pp-subs-empty">Вы пока ни на кого не подписаны</p>
          ))}

          <div className="pp-stats-grid">
            <div className="pp-badges-row">
              <span>Слоники</span>
              <div className="pp-badges-icons">
                {(userProfile?.badges || []).map((key, i) => (
                  <span key={key + i} className="pp-badge-icon" title={BADGE_LABELS[key] || key}>
                    <ElephantBadgeIcon size={28} pink={key === 'pink_elephant'} />
                  </span>
                ))}
                {(!userProfile?.badges || userProfile.badges.length === 0) && (
                  <span className="pp-badges-empty">пока нет</span>
                )}
              </div>
            </div>
          </div>

        </AccordionBlock>
      )}


      {isModerator && (
        <AccordionBlock title="Статистика" isOpen={openSection==="sysstat"}
          onToggle={()=>{toggle("sysstat");if(openSection!=="sysstat")loadSysStats();}}>
          {sysStatsLoading&&<p className="pp-stats-loading">Загрузка...</p>}
          {sysStats&&<div className="pp-stats-grid">
            <span>Друзей</span><b>{sysStats.friends??0}</b>
            <span>Админов</span><b>{sysStats.admins??0}</b>
            <span>Учителей</span><b>{sysStats.teachers??0}</b>
            <span>В бане</span><b>{sysStats.blocked??0}</b>
            <span>Онлайн</span><b>{onlineUserCount??0}</b>
            <span>Интерес за день</span><b>{sysStats.visited_today??0}</b>
            <span>Всего</span><b>{sysStats.total??0}</b>
            <span className="pp-pending-link" onClick={()=>{setShowPending(p=>!p);if(!pendingUsers)loadPendingUsers();}}>Ожидают одобрения</span>
            <b className="pp-pending-link" onClick={()=>{setShowPending(p=>!p);if(!pendingUsers)loadPendingUsers();}}>{sysStats.pending??0}</b>
          </div>}
          {!sysStatsLoading&&!sysStats&&<p className="pp-stats-loading">Нет данных</p>}
          {showPending&&(
            <div className="pp-pending-list">
              {pendingLoading&&<p className="pp-stats-loading">Загрузка...</p>}
              {pendingUsers&&pendingUsers.length===0&&<p className="pp-stats-loading">Нет ожидающих</p>}
              {pendingUsers&&pendingUsers.length>0&&<>
                <div className="pp-pending-header">
                  <input type="checkbox" checked={checkedIds.length===pendingUsers.length&&pendingUsers.length>0} onChange={e=>setCheckedIds(e.target.checked?pendingUsers.map(u=>u.id):[])}/>
                  <span>Выбрать всех</span>
                </div>
                {pendingUsers.map(u=>(
                  <label key={u.id} className="pp-pending-row">
                    <input type="checkbox" checked={checkedIds.includes(u.id)} onChange={e=>setCheckedIds(p=>e.target.checked?[...p,u.id]:p.filter(x=>x!==u.id))}/>
                    <span>{u.nickname||u.email}</span>
                  </label>
                ))}
                <button className="pp-pending-approve" disabled={!checkedIds.length||approving} onClick={approveSelected}>{approving?'Одобряем...':'Одобрить'}</button>
              </>
            }
            </div>
          )}
        </AccordionBlock>
      )}

      {/* Статистика */}
      {!isModerator && (
      <AccordionBlock
        title="Слова"
        isOpen={openSection === 'stats'}
        onToggle={() => toggle('stats')}
        dataLessonTarget="section-stats"
      >
        <div className="pp-stats-grid">
          <span>Категории</span><b>{profileStats?.categories ?? 0}</b>
          <span>Подкатегории</span><b>{profileStats?.subcategories ?? 0}</b>
          <span>Слова и фразы</span><b>{profileStats?.words ?? 0}</b>
          <span>Карточки слов</span><b>{profileStats?.wordCards ?? 0}</b>
          <span>Переводы</span><b>{profileStats?.translations ?? 0}</b>
          <span>Синонимы</span><b>{profileStats?.synonyms ?? 0}</b>
          <span>Антонимы</span><b>{profileStats?.antonyms ?? 0}</b>
          <span>Корни</span><b>{profileStats?.roots ?? 0}</b>
          <span>Фото слов</span><b>{profileStats?.photos ?? 0}</b>
          <span>Тексты</span><b>{profileStats?.savedTexts ?? 0}</b>
          <span>Архивы текстов</span><b>{profileStats?.archives ?? 0}</b>
          <span>Выучено</span><b>{profileStats?.learned ?? 0}</b>
          <span>Сложные</span><b>{profileStats?.difficult ?? 0}</b>
          <span>Показано карт</span><b>{profileStats?.totalSeen ?? 0}</b>
          <span>Подписчики на фразы</span><b>{profileStats?.subscribers_count ?? 0}</b>
          <span>У меня в избранном</span><b>{profileStats?.starred_count ?? 0}</b>
        </div>
        <button type="button" className="pp-stats-download-link" data-lesson-target="btn-download-all" onClick={() => { onDownloadAllWords && onDownloadAllWords(); }}>
          Скачать всю базу слов
        </button>
      </AccordionBlock>
      )}


      {/* База */}
      <AccordionBlock
        title="База"
        isOpen={openSection === 'database'}
        onToggle={() => toggle('database')}
        dataLessonTarget="section-database"
      >
        <button className="pp-settings-item" type="button" onClick={() => { onDownloadDatabase && onDownloadDatabase(); }}>
          ⬇  Скачать базу
        </button>
        <label className="pp-settings-item pp-avatar-label" data-lesson-target="btn-avatar">
          ⬆  Загрузить базу
          <input type="file" accept=".txt,.json,application/json,text/plain" onChange={(e) => { onImportDatabase && onImportDatabase(e); }} />
        </label>
        <button className="pp-settings-item" type="button" onClick={() => { onOpenBackupRestore && onOpenBackupRestore(); }}>
          ↺  Восстановить из архива
        </button>
      </AccordionBlock>
      {/* Настройки */}
      <AccordionBlock
        title="Настройки"
        isOpen={openSection === 'settings'}
        onToggle={() => toggle('settings')}
        dataLessonTarget="section-settings"
      >
        <label className="pp-settings-item pp-avatar-label">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="8" r="5" stroke="currentColor" strokeWidth="2"/><path d="M3 21c0-5 4-8 9-8s9 3 9 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>
          Заменить аватар
          <input type="file" accept="image/jpeg,image/png,image/webp,image/heic,image/heif" onChange={changeProfileAvatar} />
        </label>
        {onOpenVoiceSetup && (
          <button className="pp-settings-item" type="button" onClick={onOpenVoiceSetup}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none"><path d="M12 2a3 3 0 0 1 3 3v6a3 3 0 0 1-6 0V5a3 3 0 0 1 3-3z" stroke="currentColor" strokeWidth="2"/><path d="M5 11a7 7 0 0 0 14 0M12 18v3" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>
            Определить голос
          </button>
        )}
        <button className="pp-settings-item" type="button" data-lesson-target="btn-skeleton" onClick={async () => {
          const proceed = requestConfirm
            ? await requestConfirm('Добавить стандартные части речи в твою базу? Существующие категории и слова не пострадают, а скрытые вернутся.', { title: 'Стандартные части речи', confirmLabel: 'Добавить', tone: 'normal' })
            : true;
          if (proceed) {
            addDefaultSkeleton && addDefaultSkeleton();
          }
        }}>
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none"><path d="M12 5v14M5 12h14" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>
          Добавить стандартные части речи
        </button>
        <button className="pp-settings-item" type="button" data-lesson-target="btn-reload" onClick={() => window.location.reload()}>
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none"><path d="M21 12a9 9 0 1 1-2.64-6.36M21 3v6h-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
          Перезагрузить
        </button>
        <button className="pp-settings-item pp-settings-logout" type="button" data-lesson-target="btn-logout" onClick={logoutUser}>
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
          Выйти
        </button>
        {userProfile?.role==="user"&&<button className="pp-settings-item pp-settings-danger" type="button" data-lesson-target="btn-delete" onClick={deleteUserAccount}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>
          Удалить аккаунт
        </button>}
      </AccordionBlock>


      {photoModal&&(
        <div className="pp-photo-modal" onClick={()=>setPhotoModal(null)}>
          <div className="pp-photo-modal-inner" onClick={e=>e.stopPropagation()}>
            <img src={photoModal} alt="" className="pp-photo-modal-img" />
            <button className="pp-photo-modal-close" onClick={()=>setPhotoModal(null)}>✕</button>
          </div>
        </div>
      )}
    </aside>
  );
}
